import Typography from "@material-ui/core/Typography";
import MaterialLink from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";

import ErrorBoundary from "common/error-boundary/error-boundary.component";
import LoginFallback from "features/login-screen/login-form/views/login-form.fallback";
import loginStyles from "features/login-screen/login.styles";
import LoginForm from "features/login-screen/login-form/views/login-form.component";

const useStyles = makeStyles(loginStyles);

function MainPanel() {
  const classes = useStyles();

  return (
    <main className={classes.mainPanel}>
      <div className={classes.paper}>
        <ErrorBoundary fallback={<LoginFallback />}>
          <Typography
            variant="body1"
            gutterBottom
            className={classes.centeredText}
          >
            Welcome back!
          </Typography>
          <LoginForm />
          <Typography variant="caption" className={classes.smallText}>
            By clicking here, you agree to our&nbsp;
            <MaterialLink
              href="https://www.fyisoft.com/privacy-policy/"
              color="inherit"
            >
              <Typography
                variant="caption"
                color="textSecondary"
                className={classes.smallText}
              >
                Privacy Policy
              </Typography>
            </MaterialLink>
          </Typography>
        </ErrorBoundary>
      </div>
    </main>
  );
}

export default MainPanel;
